import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ChallengeSwitches({
    challenge,
    toggleActive,
    toggleSearchable,
    toggleExpired,
    toggleAffiliate,
    toggleLocked,
    setChallengeLiveAt,
    lockedLimit,
    setLockedLimit,
    lockedLimitEditable,
    lockedChallengePassword,
    setLockedChallengePassword,
}) {
    return (
        <>
            <Row className="mb-3 align-items-end">
                <Form.Group as={Col} md="2">
                    <Form.Check
                        type="switch"
                        id="activeswitch"
                        label="Active"
                        checked={challenge.IsActive}
                        onChange={toggleActive}
                    />
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Check
                        type="switch"
                        id="searchableswitch"
                        label="Searchable"
                        checked={challenge.IsSearchable}
                        onChange={toggleSearchable}
                        defaultValue={false}
                    />
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Check
                        type="switch"
                        id="expiredswitch"
                        label="Expired"
                        checked={challenge.IsExpired}
                        onChange={toggleExpired}
                        defaultValue={false}
                    />
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Check
                        type="switch"
                        id="affiliateswitch"
                        label="Affiliates"
                        checked={challenge.Affiliate}
                        onChange={toggleAffiliate}
                        defaultValue={false}
                    />
                </Form.Group>
                <Form.Group as={Col} md="4">
                    <Form.Label>Live Date</Form.Label>
                    <div>
                        <DatePicker
                            selected={challenge.LiveAt}
                            onChange={setChallengeLiveAt}
                            showTimeSelect
                        />
                    </div>
                </Form.Group>
            </Row>

            <Row className="mb-3 align-items-end">
                <Form.Group as={Col} md="2">
                    <Form.Check
                        type="switch"
                        id="lockedswitch"
                        label="Locked"
                        checked={challenge.IsLocked}
                        onChange={toggleLocked}
                    />
                </Form.Group>

                {challenge.IsLocked && (
                    <Form.Group as={Col} md="4">
                        <Form.Label>Limit (0 for unlimited)</Form.Label>
                        <Form.Control
                            type="number"
                            id="lockedlimit"
                            step="1"
                            min="0"
                            value={lockedLimit}
                            onChange={e => setLockedLimit(parseInt(e.target.value, 10))}
                            disabled={
                                lockedLimitEditable ||
                                (lockedChallengePassword != null && lockedChallengePassword !== "")
                            }
                        />
                    </Form.Group>
                )}

                {challenge.IsLocked &&
                    challenge.IsLockedLimit == null &&
                    lockedLimit < 1 && (
                        <Form.Group as={Col} md="5">
                            <Form.Label>Passcode</Form.Label>
                            <Form.Control
                                name="LockedChallengePassword"
                                type="text"
                                placeholder="Challenge Password"
                                value={lockedChallengePassword ?? ''}
                                onChange={e => setLockedChallengePassword(e.target.value)}
                            />
                        </Form.Group>
                    )}
            </Row>
        </>
    );
}
